import { gql } from '@apollo/client';

export const TAGS_QUERY = gql`
    query {
        tags{
            edges{          
                node{
                    id
                    name
                    slug
                    metadata
                    createdAt
                    updatedAt
                }
            }
        }
    }
`;
